import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DevoteeBookPooja from './bookPooja';
import HallRentalComponent from './hallRental';
import ServiceDonation from '../../devoteeService/Donation/donation';
import PrasadamPurchase from '../../devoteeService/Purchase/prasadamPurchase';
import Vastaras from '../../devoteeService/Vastras/vastaras';
import { getUserName } from '../../../infrastructure/backendService';
import HallScheduleForm from '../../hallContractForm/hallScheduleForm/hallScheduleForm';
import { SubRoutingURLs } from '../../common/RoutingURLs';

const DevoteeBookingRoutes = () => {
   const { devoteeBookingType } = useParams();

   const navigate = useNavigate();

   //    useEffect(() => {
   //       if (!checkAuthToken()) {
   //          navigate('/');
   //       }
   //    }, [getaccessToken()]);

   let componentToRender: JSX.Element;

   switch (devoteeBookingType) {
      case SubRoutingURLs.POOJA_BOOKING_REQUEST:
         componentToRender = <DevoteeBookPooja showHeaders={false} />;
         break;
      case SubRoutingURLs.EVENT_HALL_BOOKING_REQUEST:
         componentToRender = <HallRentalComponent showHeaders={false} />;
         break;
      case SubRoutingURLs.eventHallContractForm:
         componentToRender = <HallScheduleForm />;
         break;
      case SubRoutingURLs.DONATION:
         componentToRender = <ServiceDonation showHeaders={true} username={getUserName()?.toUpperCase() || ""} />;
         break;
      case SubRoutingURLs.LADDU_OR_KARASEV_OR_VADA:
         componentToRender = <PrasadamPurchase showHeaders={true} username={getUserName()?.toUpperCase() || ""} />;
         break;
      case SubRoutingURLs.VASTRA:
         componentToRender = <Vastaras showHeaders={true} username={getUserName()?.toUpperCase() || ""} />;
         break;
      default:
         componentToRender = <div>Page not found</div>;
   }

   return <>{componentToRender}</>;
};

export default DevoteeBookingRoutes;

